import { render, staticRenderFns } from "./meterUserAccountChangeRecordList.vue?vue&type=template&id=28971aac&scoped=true"
import script from "./meterUserAccountChangeRecordList.vue?vue&type=script&lang=js"
export * from "./meterUserAccountChangeRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28971aac",
  null
  
)

export default component.exports